import React from 'react';
import Divider, { dividerClasses as muiDividerClasses } from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
export { muiDividerClasses as dividerClasses };
const StyledDivider = styled(Divider)(({ theme, orientation }) => (Object.assign({ borderColor: theme.palette.customDivider.border.color }, (orientation === 'vertical'
    ? { borderRightWidth: theme.palette.customDivider.border.width }
    : { borderBottomWidth: theme.palette.customDivider.border.width }))));
const BDSDivider = props => {
    return React.createElement(StyledDivider, Object.assign({}, props));
};
export default BDSDivider;
//# sourceMappingURL=Divider.js.map